import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function Additemform(props) {
  const classes = useStyles();
  const [name, setname] = useState();
  const [description, setdescription] = useState("");
  const [unitprice, setunitprice] = useState("0");
  const [currency, setcurrency] = useState("USD");
  const [isActive, setIsActive] = useState("1");
  const [isactive, setisactive] = useState(true);
  const [errorflag, setflag] = useState("");
  const [iswaiting, setiswaiting] = useState(false);
  const [itemSize, setItemSize] = useState("0");

  const handlesubmit = (event) => {
    event.preventDefault();
    setiswaiting(true);
    if (isactive) {
      setIsActive("1");
    } else {
      setIsActive("0");
    }
    addservicearea();
  };
  const addservicearea = () => {
    let Data = {
      category_id: "",
      name: name,
      description: description,
      unit_price: unitprice, // unit price is static
      currency: currency,
      is_active: isActive,
      size: itemSize,
      type: "1",
    };
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/add_item",
      method: "POST",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setiswaiting(false);
        props.history.push("/admin/items");
      } else {
        setiswaiting(false);
        setflag(res.message);
      }
    });
  };
  const handleback = () => {
    props.history.push({ pathname: props.history.location.state.route });
  };
  const handlename = (event) => {
    setname(event.target.value);
  };
  const handledescription = (event) => {
    setdescription(event.target.value);
  };
  const handleunitprice = (event) => {
    setunitprice(event.target.value);
  };
  const handleisactivechanged = (event) => {
    if (isactive) {
      setisactive(false);
    } else if (!isactive) {
      setisactive(true);
    }
  };
  if (iswaiting) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <ArrowBackIcon
          className="backarrow pointer-point"
          color="primary"
          onClick={handleback}
        ></ArrowBackIcon>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Add Items
          </Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="name"
                  onChange={handlename}
                  label="Name"
                  name="Name"
                  autoFocus
                />
              </Grid>
            </Grid>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={handledescription}
              name="description"
              label="Description"
              id="description"
            />
            {/* <TextField
              variant="outlined"
              margin="normal"
              type="number"
              required
              fullWidth
              onChange={handleunitprice}
              name="unitprice"
              label="Unit Price"
              id="unitprice"
            /> */}
            <TextField
              required
              id="outlined-select-currency-native"
              select
              label="Item Size"
              className="mt-3 w-100"
              value={itemSize}
              onChange={(e) => setItemSize(e.target.value)}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
            >
              <option value="0">Extra Small</option>
              <option value="1">Small</option>
              <option value="2">Medium</option>
              <option value="3">Large</option>
              <option value="4">Extra Large</option>
            </TextField>
            <div className="pt-2">
              Status:
              <Switch
                checked={isactive}
                onChange={handleisactivechanged}
                color="primary"
                name="status"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </div>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Add Item
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
}
export default withRouter(Additemform);
